var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-grid__item",class:{'t-grid__item--avtive': _vm.isSelected},style:({
    background: _vm.backgroundColor,
    border: ("1px solid " + _vm.backgroundColor)
  }),on:{"click":function($event){_vm.$emit('click')}}},[_vm._v("\n  "+_vm._s(_vm.txt)+"\n  "),(_vm.isSelected)?_c('div',{staticClass:"t-grid__flag"},[_c('i',{staticClass:"el-icon-check t-grid__icon"})]):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40099788","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TGridItem/index.vue
// module id = null
// module chunks = 